import { render, staticRenderFns } from "./icon-button.vue?vue&type=template&id=11e56460&scoped=true"
import script from "./icon-button.vue?vue&type=script&lang=js"
export * from "./icon-button.vue?vue&type=script&lang=js"
import style0 from "./icon-button.vue?vue&type=style&index=0&id=11e56460&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e56460",
  null
  
)

export default component.exports